<template>
  <div class="dict">
    <div class="tableStyle">
      <!--新增/删除按钮-->
      <vxe-toolbar size="mini" v-if="!isEdit">
        <template v-slot:buttons>
          <vxe-button type="primary" class="vxe-btn-save" @click="insertEvent()"
            ><svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-add"
            />{{ $t('xTable.insert') }}</vxe-button
          >
          <vxe-button type="primary" class="vxe-btn-delete" @click="deleteEvent()"
            ><svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-white-delete"
            />{{ $t('xTable.delete') }}</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="xTable"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="goodRules"
        :edit-config="editConfig"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
        <vxe-table-column
          field="batchNo"
          width="200"
          :title="$t('lossOverflowReport.goodList.batchNo')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <!-- <search-table
                  v-model="row.batchNo"
                  searchType="warehouseBatch"
                  :isMultiple="true"
                  :currentValue="row.batchNo||null"
                  :checkRowKeys="row.batchNo"
                    @input="(val) => setInboundNo(val,select,row)"
                ></search-table> -->
            <SearchTable
              v-model="row.batchNo"
              searchType="inboundNewNo"
              :isMultiple="true"
              :currentValue="row.batchNo || null"
              :extraData="extraData"
              @input="(val) => setInboundNo(val, row)"
            ></SearchTable>
            <!-- <SearchModal
              width="800"
              ref="searchModal"
              propName="batchNo"
              propCode="batchNo"
              className="customer-search"
              :model="row.batchNo"
              :placeholder="$t('lossOverflowReport.goodList.batchNoPlaceholder')"
              :API="inboundList.API"
              :query="inboundList.query"
              :searchColumns="inboundList.searchColumns"
              :page="true"
              :isMultiple="true"
              :currentValue="row.batchNo"
              :checkRowKeys="[row.batchNo]"
              :columnList="inboundList.columnList"
              @setSearchModal="(val, select) => setInboundNo(val, select, row)"
            ></SearchModal> -->
          </template>
        </vxe-table-column>
        <!-- sunxueping TAPD【ID1000891】结算批次号关联添加 -->
        <vxe-table-column
          field="settleBatchNo"
          width="200"
          :title="'结算批次号'"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <search-table
              v-model="row.settleBatchNo"
              searchType="settle"
              :isMultiple="true"
              :currentValue="row.settleBatchNo || null"
              :extraData="{
                businessInboundBatchNo: row.batchNo,
              }"
              @input="(val) => settleBatchNoChange(val, row)"
            ></search-table>
          </template>
        </vxe-table-column>
        <!-- =========================================== -->
        <vxe-table-column
          field="productNo"
          width="160"
          :title="$t('lossOverflowReport.goodList.productNo')"
        >
        </vxe-table-column>
        <vxe-table-column
          field="productName"
          width="160"
          :title="$t('lossOverflowReport.goodList.productName')"
        />
        <vxe-table-column
          field="partnerName"
          width="160"
          :title="$t('lossOverflowReport.goodList.partner')"
        />
        <vxe-table-column
          field="decreaseOverflowQuantity"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowQuantity')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <input-number-ad
              v-model="row.decreaseOverflowQuantity"
              :max="999999999.999"
              :precision="$globalVar.qPoint"
              @input="(val) => changeAmount(val, row)"
            ></input-number-ad>
          </template>
          <template v-slot="{ row }">{{
            (decreaseOverflowType ? (decreaseOverflowType == '0' ? '- ' : '+') : '') +
            $baseRequest.formatTableColumn(row.decreaseOverflowQuantity, $globalVar.qPoint)
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="decreaseOverflowPackage"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowPackage')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <input-number-ad
              v-model="row.decreaseOverflowPackage"
              :max="999999999.999999"
              :precision="$globalVar.qPoint"
              @input="(val) => changePackage(val, row)"
            ></input-number-ad>
          </template>
          <template v-slot="{ row }">
            <div v-if="row.decreaseOverflowPackage == '' || row.decreaseOverflowPackage == 0">
              {{
                (decreaseOverflowType ? (decreaseOverflowType == '0' ? '' : '') : '') +
                $baseRequest.formatTableColumn(row.decreaseOverflowPackage, $globalVar.qPoint)
              }}
            </div>
            <div v-else>
              {{
                (decreaseOverflowType ? (decreaseOverflowType == '0' ? '- ' : '+') : '') +
                $baseRequest.formatTableColumn(row.decreaseOverflowPackage, $globalVar.qPoint)
              }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="decreaseOverflowUnitName"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowUnit')"
        />
        <vxe-table-column
          field="decreaseOverflowUnitPrice"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowUnitPrice')"
        >
          <template v-slot="{ row }">
            {{ $baseRequest.formatTableColumn(row.decreaseOverflowUnitPrice, $globalVar.pPoint) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="businessDecreaseOverflowAmount"
          width="160"
          :title="$t('lossOverflowReport.goodList.businessDecreaseOverflowAmount')"
        >
          <template v-slot="scope">
            {{ $baseRequest.formatTableColumn(scope.row.businessDecreaseOverflowAmount) || 0 }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="newDecreaseOverflowPercent"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowPercent')"
        >
          <template v-slot="scope">
            {{
              $baseRequest.formatTableColumn(
                scope.row.decreaseOverflowPercent,
                $globalVar.iPoint
              ) || 0
            }}%
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="purchaseNo"
          width="160"
          :title="$t('lossOverflowReport.goodList.purchaseNo')"
        />
        <vxe-table-column
          field="puchaseDetailNo"
          width="160"
          :title="$t('lossOverflowReport.goodList.puchaseDetailNo')"
        />
        <vxe-table-column
          field="puchaseDetailQuantity"
          width="160"
          :title="$t('lossOverflowReport.goodList.puchaseDetailQuantity')"
        >
          <template v-slot="scope">
            {{ $baseRequest.formatTableColumn(scope.row.puchaseDetailQuantity, $globalVar.qPoint) }}
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import rules from '../rules/rules';
  import API from '@/api/wareHouse/lossOverflowReport.js';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import searchTable from '@/components/form-item/search-table';
  // import SearchModal from '@/components/SearchModal';
  export default {
    name: 'reportProduct',
    components: {
      inputNumberAd,
      searchTable,
      // SearchModal,
    },
    data() {
      return {
        goodRules: rules.productRules,
        editConfig: {},
        tableData: this.defaultData,
        storage: this.storageNo,
      };
    },
    props: {
      //初始化数据
      defaultData: {
        type: Array,
        default: () => [],
      },
      //是否编辑
      isEdit: {
        type: Boolean,
        default: () => false,
      },
      //仓库编码
      storageNo: {
        type: String,
        default: '',
      },
      //部门
      departmentCode: {
        type: String,
        default: '',
      },
      //单据类型
      decreaseOverflowType: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      extraData() {
        return {
          storageNo: this.storage,
          tenantCode: this.userInfo.userInfo.tenantCode,
          batchDepartmentNo: this.departmentCode,
          inboundStatus: '02',
          inboundType: '0',
          ...(this.decreaseOverflowType == '0'
            ? {
                quantityFlag: 1,
                storageQuantity: 0,
              }
            : ''),
        };
      },
      //业务入库批次
      inboundList() {
        return {
          width: '800',
          query: {
            storageNo: this.storage,
            tenantCode: this.userInfo.userInfo.tenantCode,
            // companyCode:this.userInfo.userInfo.companyCode,
            batchDepartmentNo: this.departmentCode,
            inboundStatus: '02',
            inboundType: '0',
            productName: null,
            // startGmtCreate:null,
            // endGmtCreate:null,
            contractInternalNo: null,
            batchNo: null,
            storageName: null,
            partnerName: null,
            // marineLadingNo:null,
            // warehouseReceiptsNo:null,
            // settleBatchNo:null,
            productDetailNo: null,
            // nameVoyageLicense:null,
            distributionBatchNo: null,
            ...(this.decreaseOverflowType == '0'
              ? {
                  quantityFlag: 1,
                  storageQuantity: 0,
                }
              : ''),
          },
          API: API.GET_INBOUND_NEW,
          searchColumns: [
            {
              prop: 'productName',
              name: this.$t('businessReceiptList.search.productName'),
              type: 'input',
            },
            // {
            //     prop: "startGmtCreate",
            //     name: this.$t("businessReceiptList.search.startGmtCreate"),
            //     type: "startDaterangePicker",
            // },
            // {
            //     prop: "endGmtCreate",
            //     name: this.$t("businessReceiptList.search.endGmtCreate"),
            //     type: "endDaterangePicker",
            // },
            {
              prop: 'contractInternalNo',
              name: this.$t('businessReceiptList.search.contractInternalNo'),
              type: 'input',
            },
            {
              prop: 'batchNo',
              name: this.$t('businessReceiptList.search.batchNo'),
              type: 'input',
            },
            {
              prop: 'storageName',
              name: this.$t('businessReceiptList.search.storageName'),
              type: 'input',
            },
            {
              prop: 'partnerName',
              name: this.$t('businessReceiptList.search.partnerName'),
              type: 'input',
            },
            // {
            //     prop: "marineLadingNo",
            //     name: this.$t("businessReceiptList.search.marineLadingNo"),
            //     type: "input",
            // },
            // {
            //     prop: "warehouseReceiptsNo",
            //     name: this.$t("businessReceiptList.search.warehouseReceiptsNo"),
            //     type: "input",
            // },
            // {
            //     prop: "settleBatchNo",
            //     name: this.$t("businessReceiptList.search.settleBatchNo"),
            //     type: "input",
            // },
            {
              prop: 'productDetailNo',
              name: this.$t('businessReceiptList.search.productDetailNo'),
              type: 'input',
            },
            // {
            //     prop: "nameVoyageLicense",
            //     name: this.$t("payablesBillList.form.good.nameVoyageLicense"),
            //     type: "input",
            // },
            // {
            //     type: "input",
            //     prop: "distributionBatchNo",
            //     name: this.$t('logistics.commodityMarket.distributionBatchNo'),
            // },
          ],
          columnList: [
            {
              prop: 'batchNo',
              label: this.$t('businessReceiptList.search.incomingBatch'),
              fixed: 'left',
              width: 140,
            },
            {
              prop: 'storageQuantity',
              label: this.$t('businessReceiptList.table.storageQuantity'),
              fixed: 'left',
              width: 100,
            },
            { prop: 'availableQuantity', label: '可用库存数量', fixed: 'left', width: 100 },
            { prop: 'storageName', label: this.$t('businessReceiptList.search.storageName') },
            {
              prop: 'productName',
              label: this.$t('businessReceiptList.search.productName'),
              width: 120,
            },
            { prop: 'gmtCreate', label: this.$t('businessReceiptList.table.gmtCreate') },
            { prop: 'businessInboundNo', label: this.$t('businessReceiptList.table.inboundNo') },
            {
              prop: 'contractInternalNo',
              label: this.$t('businessReceiptList.search.contractInternalNo'),
            },
            { prop: 'storagePrice', label: '库存实时单价' },
            { prop: 'inboundCompanyWithouttaxPrice', label: '本币入库不含税单价' },
            { prop: 'partnerName', label: this.$t('businessReceiptList.search.partnerName') },
            // { prop: "marineLadingNo", label: this.$t("businessReceiptList.search.marineLadingNo"),  },
            { prop: 'storageName', label: '仓库' },
            // { prop: "settleBatchNo", label: this.$t("businessReceiptList.search.settleBatchNo"),  },
            // { prop: "nameVoyageLicense", label:this.$t("payablesBillList.form.good.nameVoyageLicense"),  },
            // { prop: "distributionBatchNo", label:this.$t('logistics.commodityMarket.distributionBatchNo'),  },
          ],
        };
      },
    },
    mounted() {
      this.editConfig = this.isEdit ? {} : { trigger: 'click', mode: 'row' };
    },
    watch: {
      isEdit(newValue) {
        this.editConfig = newValue ? {} : { trigger: 'click', mode: 'row' };
      },
      defaultData(newValue) {
        this.tableData = newValue;
      },
      storageNo(newVlaue) {
        this.storage = newVlaue;
      },
      decreaseOverflowType(newV, oldV) {
        console.log(newV, oldV);
        if (oldV && newV !== oldV) {
          this.tableData = [];
        }
      },
    },
    methods: {
      //新增一行
      insertEvent() {
        if (!this.storage) {
          this.$message({
            showClose: true,
            message: this.$t('lossOverflowReport.msg.selectWarehouse'),
            type: 'error',
          });
          return;
        }
        const record = {
          batchNo: null,
          settleBatchNo: null,
          productNo: null,
          productName: null,
          partnerName: null,
          decreaseOverflowQuantity: 0,
          decreaseOverflowPackage: 0,
          decreaseOverflowUnit: null,
          decreaseOverflowUnitPrice: null,
          businessDecreaseOverflowAmount: null,
          decreaseOverflowPercent: 0,
          purchaseNo: null,
          puchaseDetailNo: null,
          puchaseDetailQuantity: null,
          newDecreaseOverflowPercent: 0,
        };
        this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
      },
      //删除行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          //删除时记录删除明细id
          // selectRecords.map(item => {
          //   if (item.id) {
          //     this.orderDetailDelIds.push(item.id);
          //   }
          // });
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //选择业务入库批次
      setInboundNo(value, row) {
        console.log(value, row, '????');
        // =========sunxueping TAPD【ID1000891】结算批次号关联添加=========
        row.settleBatchNo = null;
        // ==============================================================
        row.batchNo = value ? value[0].batchNo : null;
        row.productNo = value ? value[0].productDetailNo : null;
        row.productName = value ? value[0].productName : null;
        row.partnerNo = value ? value[0].partnerNo : null;
        row.partnerName = value ? value[0].partnerName : null;
        row.decreaseOverflowUnit = value ? value[0].productUnit : null;
        row.decreaseOverflowUnitName = value
          ? this.$baseRequest.getDictValueByType('basic_unit', value[0].productUnit)
          : null;
        //row.decreaseOverflowUnitPrice =value? value[0].businessContractPrice
        row.decreaseOverflowUnitPrice = value
          ? this.decreaseOverflowType == '0'
            ? value[0].storagePrice
            : value[0].inboundCompanyWithouttaxPrice
          : null; //入库单价
        row.purchaseNo = value ? value[0].contractInternalNo : null; //采购合同号/意向单号
        row.puchaseDetailNo = value ? value[0].contractInternalDetailNo : null; //合同行项目号
        row.inboundQuantity = value ? value[0].inboundQuantity : null; //入库数量
        row.leftInboundQuantity = value ? value[0].storageQuantity : null; //库存数量
        row.decreaseOverflowQuantity =
          value && this.decreaseOverflowType == '0' ? value[0].storageQuantity : null; //损溢数量
        if (value && value.length > 0) {
          let params = {
            contractNo: value[0].contractInternalNo, //合同号
            contractDetailNo: value[0].contractInternalDetailNo, //合同行项目号
            flag: 0, //标记
          };
          //根据合同号查询合同数量
          this.$axios.post(API.CONTRSACT_DETAIL, params).then((res) => {
            if (res.data.code === 0) {
              row.puchaseDetailQuantity = res.data.data ? res.data.data.productQuantity : 0;
              this.$refs.xTable.updateStatus(row);
            }
          });
          if (row.leftInboundQuantity && row.decreaseOverflowUnitPrice) {
            this.changeAmount(row.leftInboundQuantity, row);
          }
        }
      },
      // =========sunxueping TAPD【ID1000891】结算批次号关联添加=========
      // 选择结算批次号
      settleBatchNoChange(value, row) {
        row.settleBatchNo = value ? value[0].settleNo : null;
      },
      // ==============================================================
      //修改数量
      changeAmount(val, row) {
        row.allotOutAmount = val;
        let params = {
          returnQuantity: val,
          returnUnitPrice: row.decreaseOverflowUnitPrice,
        };
        if (params.returnQuantity && params.returnUnitPrice) {
          //计算损溢金额
          this.$axios.post(API.GET_AMOUNT, params).then((res) => {
            if (res.data.code === 0) {
              row.businessDecreaseOverflowAmount = Number(res.data.data.returnMoneyAmount).toFixed(
                6
              );
              this.$refs.xTable.updateStatus(row);
            }
          });
        }
        let data = {
          decreaseOverflowPackage: val,
          inboundQuantity: row.inboundQuantity || 0,
        };
        if (data.decreaseOverflowPackage && data.inboundQuantity) {
          //计算损溢比例
          this.$axios.post(API.GET_SCALE, data).then((res) => {
            if (res.data.code === 0) {
              row.decreaseOverflowPercent = Number(res.data.data).toFixed(8);
              row.newDecreaseOverflowPercent =
                Number(row.decreaseOverflowPercent, 100).toFixed(6) + '%';
              this.$refs.xTable.updateStatus(row);
            }
          });
        } else {
          row.decreaseOverflowPercent = 0;
          row.newDecreaseOverflowPercent =
            Number(row.decreaseOverflowPercent, 100).toFixed(6) + '%';
        }
      },
      //修改件数
      changePackage(val, row) {
        row.allotOutPackage = val;
      },
      //提交/保存
      submit(type) {
        return new Promise((resolve) => {
          if (type == '0') {
            resolve();
          } else {
            this.$refs['xTable'].validate((valid, object) => {
              if (valid) {
                resolve();
              } else {
                this.$refs.xTable.scrollToColumn(object);
                const getTableData = this.$refs.xTable.getTableData().fullData;
                if (getTableData.length == 1) {
                  setTimeout(() => {
                    this.$refs.xTable.scrollTo(null, 50);
                  }, 500);
                }
              }
            });
          }
        });
      },
      //获取表格所有数据
      getValues() {
        const getTableData = this.$refs.xTable.getTableData().fullData;
        let list = [];
        getTableData.forEach((item, index) => {
          const result = Object.assign({}, item, {
            //项目行序号
            decreaseOverflowDetailNo: index + 1,
          });
          list.push(result);
        });
        return list;
      },
    },
  };
</script>
